<template>
	<div>
		<header>
			<h1>Create Group</h1>
		</header>
		<div>
			<group-form cta="Create Group"/>
		</div>
	</div>
</template>
<script>
export default {};
</script>
